/** 75.4 → "1:15.4"; 9.05 → "0:09.1". Compact m:ss(.t) for marker chips. */
export function formatTime(seconds: number): string {
  const s = Math.max(0, seconds);
  const mins = Math.floor(s / 60);
  const rem = s - mins * 60;
  const whole = Math.floor(rem);
  const tenth = Math.round((rem - whole) * 10);
  const frac = tenth > 0 && tenth < 10 ? `.${tenth}` : '';
  return `${mins}:${String(whole).padStart(2, '0')}${frac}`;
}
